import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=97a8c390&scoped=true&lang=pug"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=97a8c390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a8c390",
  null
  
)

export default component.exports